import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { SimpleTableComponent } from '../../generals/Components';
import { ProductItem } from '../../interfaces/interfaces';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent extends SimpleTableComponent<ProductItem> {

  constructor(
    private apiServiceRef: ApiService,
    private changeDetectionRef: ChangeDetectorRef
  ) {
    super(changeDetectionRef, apiServiceRef);
    this.endPoint = 'products';
  }

  ngOnInit(): void {
  }

}
